<template>
  <div id="consthome">
    <!-- 前三行 -->
    <div class="user-self">
      <!-- 有云资源的前两行 -->
      <div class="havecloud">
        <h-row :gutter="16">
          <h-col span="16">
            <div class="welcome user-block">
              <div>
                <div class="wel-hello">你好，{{ userInfo.name }}</div>
                <span
                  >点击可查看<a href="/openplat-doc/gtnDoc?docId=97078ddf0cde4c77ab89dbbc5e3c1efa" target="_blank"
                    >《平台使用指南》</a
                  ></span
                >
              </div>
            </div>
          </h-col>
          <h-col span="8"
            ><div class="userinfo1 user-block">
              <span class="block-title">我的信息</span>
              <div class="user-detail">
                客户全称：{{ userInfo.fullName }}
                <span class="usertype">{{ userInfo.type }}</span>
              </div>
              <div class="user-detail">客户编号：{{ userInfo.num }}</div>
            </div></h-col
          >
        </h-row>

        <!-- 第二行 -->
        <h-row :gutter="16">
          <h-col span="8">
            <!-- 余额 -->
            <!-- <div class="balance user-block">
              <span class="block-title">我的余额</span>
              <div class="balance-cloud">
                <div class="money">￥{{ balance.balance }}</div>
                <h-button
                  type="ghost"
                  class="blue"
                  @click="goUrl('/console/recharge.html')"
                  >充值</h-button
                >
              </div>

              <div class="balance-bot">
                <div class="babot-left">可用额度：￥{{ balance.balance }}</div>
                <div class="babot-right">
                  未用优惠券：
                  <a
                    href="/console/coupon_management.html"
                    target="_blank"
                    class="block-title-a big-font"
                    >{{ balance.toCoupon }}</a
                  >
                  <span style="color: #666;">张</span>
                </div>
              </div>
            </div> -->
            <div class="ploatfrom user-block">
              <div class="plo-top">
                <span class="block-title">常用服务</span>
              </div>
              <div class="common-services">
                <div
                  class="common-services-box"
                  v-for="item in commonServices"
                  :key="item.service_id"
                  :title="item.service_name"
                  @click="
                    getAliServiceLoginUrl(
                      item.service_console_url,
                      item.service_id,
                      item.cloud_resource_type
                    )
                  "
                >
                  {{ item.service_name }}
                </div>
              </div>
            </div>
          </h-col>
          <h-col span="8"
            ><!-- 云资源 -->
            <div class="cloud user-block">
              <div class="plo-top">
                <span class="block-title">我的云资源额度</span>
                <div class="cloudSource">
                  <span
                    :class="{
                      plreeclass: cloud.id == 'openCloud',
                      normarlclass: cloud.id != 'openCloud',
                    }"
                    @click="changeCloud('openCloud')"
                    >公有云</span
                  >
                  |
                  <span
                    :class="{
                      plreeclass: cloud.id == 'finaCloud',
                      normarlclass: cloud.id != 'finaCloud',
                    }"
                    @click="changeCloud('finaCloud')"
                    >金融云</span
                  >
                </div>
              </div>
              <div class="balance-cloud" v-if="userInfo.haveCloud">
                <div class="money">{{ cloud.balance }}</div>
                <h-button
                  class="blue"
                  type="ghost"
                  style="margin-right: 12px"
                  @click="goUrl(cloudUrl)"
                  >充值</h-button
                >
                <h-button
                  type="ghost"
                  class="blue"
                  @click="goUrl(cloud_market_url)"
                  >购买云服务器</h-button
                >
              </div>
              <div class="balance-cloud" v-else>
                <div class="buyTip">您还未购买云资源额度</div>
                <h-button
                  type="ghost"
                  class="blue"
                  @click="goUrl(cloud_buy_url)"
                  >充值</h-button
                >
              </div>
              <div class="balance-bot">
                <div class="babot-left">可用额度：{{ cloud.balance }}</div>
                <div class="babot-right">
                  可用额度预警：<h-switch
                    size="small"
                    v-model="cloud.switch"
                    @on-change="changeSwitch"
                  ></h-switch>
                </div>
              </div></div
          ></h-col>
          <h-col span="8"
            ><!-- 公告 -->
            <div class="ploatfrom user-block">
              <div class="plo-top">
                <span class="block-title">平台公告</span>
              </div>
              <div class="plo-block">
                <div
                  class="plo-notice"
                  v-for="(item, index) in platfromNotice.slice(0, 5)"
                  :key="index"
                >
                  <span
                    :class="[
                      'notice-type',
                      {
                        type0: item.type_id === '0',
                        type1: item.type_id === '1',
                        type2: item.type_id === '2',
                        type3: item.type_id === '3' || Number(item.type_id) > 9,
                        type4: item.type_id === '4',
                        type5: item.type_id === '5',
                        type6: item.type_id === '6',
                        type7: item.type_id === '7',
                        type8: item.type_id === '8',
                        type9: item.type_id === '9',
                      },
                    ]"
                    >{{ item.type_name }}</span
                  >
                  <a
                    :href="blogListURl(item.serial_num)"
                    target="_blank"
                    class="notice-title"
                    :title="item.blog_title"
                    >{{ item.blog_title }}</a
                  >
                </div>
              </div>
            </div>
          </h-col>
        </h-row>
      </div>

      <!-- 不受影响的三个第三行的盒子 -->
      <h-row :gutter="16">
        <h-col span="8">
          <div class="myapis user-block">
            <div class="plo-top">
              <a
                href="/console/data_analysis.html"
                target="_blank"
                class="block-title-a"
                >我的api调用</a
              >
              <div>
                <span
                  :class="{
                    plreeclass: apiInvoke.id == 'PRD',
                    normarlclass: apiInvoke.id != 'PRD',
                  }"
                  @click="changeEnvironment('PRD')"
                  >生产环境</span
                >
                |
                <span
                  :class="{
                    plreeclass: apiInvoke.id == 'UAT',
                    normarlclass: apiInvoke.id != 'UAT',
                  }"
                  @click="changeEnvironment('UAT')"
                  >测试环境</span
                >
              </div>
            </div>
            <div class="plo-center">
              <div class="pc-l">
                <span class="pc-trans">前一日调用次数</span>
                <span class="big-font">{{ apiInvoke.yesterday }}</span>
              </div>
              <div class="pc-c">
                <span class="pc-trans">本月累计调用次数</span>
                <span class="big-font" v-if="apiInvoke.thisMonth < 100000000">{{
                  apiInvoke.thisMonth
                }}</span>
                <span class="big-font" v-else :title="apiInvoke.thisMonth"
                  >100,000,000＋</span
                >
              </div>
              <div class="pc-r">
                <span class="pc-trans">成功率</span>
                <span
                  class="big-font"
                  :class="
                    apiInvoke.successRate < 90
                      ? 'redclass'
                      : apiInvoke.successRate < 95
                      ? 'yeclass'
                      : ''
                  "
                  >{{ apiInvoke.successRate }}%</span
                >
              </div>
            </div>
          </div>
        </h-col>
        <h-col span="8">
          <div class="myservice user-block">
            <div class="plo-top">
              <a
                href="/console/services.html"
                target="_blank"
                class="block-title-a"
                >我的服务</a
              >
            </div>
            <div class="plo-center">
              <div class="pc-l">
                <span class="pc-trans">已开通</span>
                <a
                  href="/console/services.html?service_status=8"
                  target="_blank"
                  class="big-font"
                  >{{ myService.hadNums }}</a
                >
              </div>
              <div class="pc-c">
                <span class="pc-trans">已到期</span>
                <a
                  href="/console/services.html?service_status=9"
                  target="_blank"
                  class="big-font"
                  >{{ myService.expireNums }}</a
                >
              </div>
              <div class="pc-r">
                <span class="pc-trans">一个月内到期</span>
                <a
                  :href="soonExpireNumsHref"
                  target="_blank"
                  class="big-font"
                  style="color: #ff5c5c"
                  >{{ myService.soonExpireNums }}</a
                >
              </div>
            </div>
          </div>
        </h-col>
        <h-col span="8">
          <div class="mygoods user-block">
            <div class="plo-top">
              <a
                href="/console/order.html"
                target="_blank"
                class="block-title-a"
                >我的订单</a
              >
            </div>
            <div class="plo-center">
              <div class="pc-l">
                <span class="pc-trans">待支付</span>
                <a
                  href="/console/order.html?order_status=1"
                  target="_blank"
                  class="big-font"
                  style="color: #4686f2"
                  >{{ myOrder.toPayNums }}</a
                >
              </div>

              <div class="pc-c">
                <span class="pc-trans">待发货</span>
                <a
                  href="/console/order.html?order_handle_status=3"
                  target="_blank"
                  class="big-font"
                  style="color: #4686f2"
                  >{{ myOrder.toSendNums }}</a
                >
              </div>
            </div>
          </div>
        </h-col>
      </h-row>
    </div>

    <!-- 推荐 -->
    <div class="user-recommend user-block">
      <div class="rec-title">为你推荐</div>
      <!-- 商品组件 -->
      <ItemCard :proItemList="recObjs" />
    </div>

    <!-- 云资源预警提示框 -->
    <h-msg-box
      v-model="msgboxShow"
      :escClose="true"
      title="可用额度预警"
      :beforeOkClose="beforeOkClose"
      :mask-closable="false"
    >
      <h-form :model="formWarning" label-position="top" ref="formWarning">
        <h-form-item
          prop="early_warning"
          label="输入预警额度，当您的可用额度低于该值时，系统会邮件通知您！"
          :validRules="test1Rule"
          required
        >
          <h-input
            v-model="formWarning.early_warning"
            placeholder="请输入..."
          ></h-input>
          <span
            style="
              position: absolute;
              color: red;
              width: 100%;
              left: 0;
              top: 30px;
            "
            v-if="beforeOkCloseShow"
          >
            {{ error_info }}
          </span>
        </h-form-item>
      </h-form>
      <!-- <p>输入预警额度，当您的可用额度低于该值时，系统会邮件通知您！</p>
      <h-input v-model="early_warning" placeholder="请输入..."></h-input> -->
      <!-- <span slot="footer">
        <h-button>取消</h-button>
        <h-button type="info">确定</h-button>
      </span> -->
    </h-msg-box>
  </div>
</template>

<script>
import ItemCard from "@/components/ItemCard.vue"
import {
  buyCloud,
  myInfo,
  myBalance,
  noticeList,
  myCloud,
  myApi,
  myService,
  myOrder,
  warningQuota,
  serviceList,
  myUseService,
} from "@/api/virtualBusiness.js"
import { getAliServiceLogin } from "@/api/service.js"
import { mapGetters, mapState } from "vuex"
export default {
  name: "ConstHome",
  data() {
    /**
     * early_warning：预警值
     * msgboxShow：预警框开关
     * userInfo： 用户信息暂定看接口再做修改
     * {name：姓名
     * fullname：全名
     * num：编号
     * type：客户类型
     * havaCloud：是否有云资源
     * }
     * balance：余额对象{balance：可用余额，toCoupon：未用优惠券数量}
     * cloud：云资源对象{id：标识该资源是公有云还是金融云（openCloud，finaCloud）
     *                   balance：云资源可用余额，switch：云资源预警开关}
     * platfromNotice：公告对象数组[{type：公告类型，title：公告标题}]，可能类型会通过数字标识，可能元素会扩展其他属性
     * apiInvoke：api调用对象
     * myService：服务对象{hadNums：已开通，expireNums：已过期，soonExpireNums：一个月内过期}
     * myOrder：我的订单
     * recObjs：传递给 ItemCard 组件的数据对象，具体看该组件内说明
     */
    return {
      cloud_market_url: "",
      cloud_buy_url: "",
      commonServices: [],
      error_info: "",
      beforeOkCloseShow: false,
      copy_early: "",
      // copy_switch: "",
      cloudUrl: "",
      test1Rule: [
        "required",
        {
          test: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/, //不包括0
          // test: /^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/,
          message: "您输入的额度信息有误，请填写正数的额度",
          trigger: "blur",
        },
      ],
      formWarning: {
        early_warning: "",
      },
      msgboxShow: false,
      userInfo: {
        // name: "nini",
        // fullName: "",
        // num: "B2020010100000",
        // type: "企业客户",
        // haveCloud: true
      },
      balance: {
        // balance: 2,
        // toCoupon: 2
      },
      cloud: {
        id: "openCloud",
        // balance: "0.00"
        // switch: false
      },
      platfromNotice: [
        // {
        //   type: "业务动态",
        //   title: "公告标题"
        // }
      ],
      apiInvoke: {
        id: "PRD",
        yesterday: "0",
        thisMonth: "0",
        successRate: 0,
      },
      myService: {
        // hadNums: 2,
        // expireNums: 2
        // soonExpireNums: 1
      },
      myOrder: {
        // toPayNums: 2,
        // toSendNums: 2
      },

      recObjs: [
        // {
        //   service_promotion_label: 1,
        //   price: -1,
        //   combo_type: 1,
        //   invoke_times: 2,
        //   used_length: 3,
        //   content: "asdjfgasfankfgnadfgpiaudgkj",
        //   service_keyword: ["精选1", "精选2"],
        //   service_name: "asjkdfa;jkfasf",
        //   service_id: "asdbfasdjkfakslkfa1l"
        // },
        // {
        //   service_promotion_label: 2,
        //   price: -1,
        //   combo_type: 1,
        //   invoke_times: 0,
        //   used_length: 3,
        //   content: "asdjfgasfankfgnadfgpiaudgkj",
        //   service_keyword: ["精选1", "精选2"],
        //   service_name: "asjkdfa;jkfas434f",
        //   service_id: "asdbfasdjkfakslk2fal"
        // },
        // {
        //   service_promotion_label: 0,
        //   price: -1,
        //   combo_type: 2,
        //   invoke_times: 2,
        //   used_length: 3,
        //   content: "asdjfgasfankfgnadfgpiaudgkj",
        //   service_keyword: ["精选1", "精选2"],
        //   service_name: ";jkfasf",
        //   service_id: "asdbfasdjkfaksl3kfal"
        // },
        // {
        //   service_promotion_label: 0,
        //   price: 2,
        //   combo_type: 1,
        //   invoke_times: 2,
        //   used_length: 3,
        //   content: "sdfsfsf",
        //   service_keyword: ["精选1", "精选2"],
        //   service_name: "asjkdfa;",
        //   service_id: "asdbfasd4jkfakslkfal"
        // }
      ],
    }
  },
  components: {
    ItemCard,
  },

  computed: {
    soonExpireNumsHref() {
      var date = new Date()
      var date2 = new Date(date)
      date2.setDate(date.getDate() + 30)
      var YYYY = date.getFullYear()
      var MM = ("0" + (date.getMonth() + 1)).slice(-2)
      var DD = ("0" + date.getDate()).slice(-2)
      var start_time = YYYY + MM + DD
      var yyyy = date2.getFullYear()
      var mm = ("0" + (date2.getMonth() + 1)).slice(-2)
      var dd = ("0" + date2.getDate()).slice(-2)
      var end_time = yyyy + mm + dd
      // console.log(date2, start_time, YYYY, MM, DD, end_time)
      return `/console/services.html?start_time=${start_time}&end_time=${end_time}`
    },
    ...mapGetters(["user"]),
  },
  watch: {
    user: {
      handler: function (val, oldVal) {
        if (val.hsid) {
          // this.isBuyCloud()
          this.getMyCloud("public")
          this.getMyInfo()
          this.getMyBalance()
          this.getMyApi("PRD")
          this.getMyOrder()
          // this.setWarningQuota()
          this.getMyService()
          this.getServiceList()
          this.getNoticeList()
        }
      },
      deep: true,
      immediate: true,
    },
    msgboxShow(v) {
      if (!v) {
        this.$refs.formWarning.resetFields()
        this.beforeOkCloseShow = false
        if (this.cloud.id == "openCloud") this.getMyCloud("public")
        else this.getMyCloud("financial")
      } else {
        // let state = this.cloud.switch
        // console.log(this.cloud.switch)
        // if (this.cloud.id == "openCloud") this.getMyCloud("public", state)
        // else this.getMyCloud("financial", state)
        // this.formWarning.early_warning = 0
        // console.log(this.cloud.switch)
        // this.$refs.formWarning.resetValidate()
        this.$refs.formWarning.resetFields()
        // if (this.copy_early) this.formWarning.early_warning = this.copy_early
      }
    },
  },
  created() {
    if (this.$store.getters.user.hsid) {
      // this.isBuyCloud()
      this.getMyInfo()
      this.getMyBalance()
      this.getMyApi("PRD")
      this.getMyOrder()
      // this.setWarningQuota()
      this.getMyService()
      this.getServiceList()
      this.getNoticeList()
      this.getMyUseService()
    }
  },

  // watch: {
  //   msgboxShow(v) {
  //     if (!v) {
  //       this.$refs.formWarning.resetFields()
  //       this.beforeOkCloseShow = false
  //     } else {
  //       this.$refs.formWarning.resetValidate()
  //       if (this.copy_early) this.formWarning.early_warning = this.copy_early
  //     }
  //   }
  // },
  methods: {
    async getAliServiceLoginUrl(login, id, type) {
      const res = await getAliServiceLogin({
        service_id: id,
        login_url: login,
        cloud_resource_type: type,
      })
      // console.log(res.error_code)
      // if (res.error_code !== "0") this.$hMessage.info("系统繁忙")
      localStorage.setItem("login_url", res.data.login_url)
      window.open("/openplat-front/service/console", "_blank")
      // window.open("/gtn.html#/service/console", "_blank")
      // this.$router.push({
      //   path: "/service/" + id
      // })
      // window.location.href = res.login_url
    },

    async getMyUseService() {
      const res = await myUseService()
      // console.log(res)
      this.commonServices = res
      // console.log(this.commonServices)
    },
    goUrl(url) {
      window.open(url, "_blank")
    },
    blogListURl(num) {
      return `/openplat-doc/informationDetail/detail/${num}`
    },
    async changeSwitch(status) {
      // console.log(this.cloud.switch)
      if (status) {
        this.msgboxShow = true
      } else {
        let flag = this.cloud.switch ? "1" : "0"
        // console.log(flag)
        const res = await this.setWarningQuota(
          0,
          this.cloud.id === "openCloud" ? "public" : "financial",
          flag
        )
      }
    },
    changeCloud(cloudId) {
      if (this.cloud.id === cloudId) {
        return
      } else if (cloudId === "openCloud") {
        this.getMyCloud("public")
        this.cloud.id = "openCloud"
        // this.cloud.switch = false
        // this.cloud.balance = 32242
      } else {
        this.getMyCloud("financial")
        this.cloud.id = "finaCloud"
        // this.cloud.switch = true
        // this.cloud.balance = 23
      }
    },
    changeEnvironment(envId) {
      if (this.apiInvoke.id === envId) {
        return
      } else if (envId === "PRD") {
        this.getMyApi("PRD")
        this.apiInvoke.id = "PRD"
      } else {
        this.getMyApi("UAT")
        this.apiInvoke.id = "UAT"
      }
    },

    beforeOkClose() {
      // var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      // console.log(reg.test(this.formWarning.early_warning))

      return new Promise((resolve, reject) => {
        this.$refs.formWarning.validate(async (valid) => {
          if (valid) {
            // console.log(this.cloud.switch)
            let flag = this.cloud.switch ? "1" : "0"
            // console.log(flag)
            const res = await this.setWarningQuota(
              this.formWarning.early_warning,
              this.cloud.id === "openCloud" ? "public" : "financial",
              flag
            )
            this.error_info = res.error_info
            // res.error_code = "0"
            if (res.error_code !== "0") {
              this.beforeOkCloseShow = true
              resolve(false)
            } else {
              resolve(true)
              this.$hMessage.success("设置额度预警成功！")
              // if (this.cloud.id == "openCloud") this.getMyCloud("public")
              // else this.getMyCloud("financial")
            }
          } else {
            resolve(false)
          }
        })
      })
    },
    // 设置额度预警
    // ok() {
    //   if (this.formWarning.early_warning !== "") {
    //     this.setWarningQuota(
    //       this.formWarning.early_warning,
    //       this.cloud.id === "openCloud" ? "public" : "financial",
    //       this.cloud.switch === true ? "1" : "0"
    //     )
    //   }
    // },

    // 是否购买云服务
    // async isBuyCloud() {
    //   const res = await buyCloud()
    //   console.log(res)
    //   // if (this.userInfo.haveCloud) this.getMyCloud("public")
    // },
    // 获取我的基础信息
    async getMyInfo() {
      const res = await myInfo()
      // console.log(res)
      this.userInfo.name = res.nike_name
      this.userInfo.fullName = res.customer_name
      this.userInfo.num = res.hsid
      this.userInfo.type =
        res.user_type === "0"
          ? "普通用户"
          : res.user_type === "1"
          ? "个人用户"
          : "企业用户"
    },
    // 获取我的余额
    async getMyBalance() {
      const res = await myBalance()
      this.$set(
        this.balance,
        "balance",
        res.account_balance == null ? "0.00" : res.account_balance.toFixed(2)
      )
      this.balance.toCoupon = res.coupon_quantity
      // console.log(res, this.balance)
    },
    // 获取我的云资源额度

    /**
     * @description 获取云状态信息
     */
    async getMyCloud(type) {
      const res = await myCloud({ cloud_resource_type: type })
      this.$set(
        this.cloud,
        "balance",
        res.cloud_resource_quota == null
          ? "0.00"
          : res.cloud_resource_quota.toFixed(2)
      )
      // console.log(res.warning_resource_quota)
      this.$set(
        this.formWarning,
        "early_warning",
        res.warning_resource_quota == null ? 0 : res.warning_resource_quota
      )
      // this.formWarning.early_warning = res.warning_resource_quota
      this.$set(this.userInfo, "haveCloud", res.open_flag == "0" ? false : true)
      // console.log(this.userInfo.haveCloud)
      // this.userInfo.haveCloud = res.open_flag === "0" ? false : true
      this.cloud_market_url = res.resource_market_address
      this.cloud_buy_url = res.resource_bundle_address
      this.cloudUrl = res.resource_bundle_address
      this.cloud.switch = res.switch_flag == "1" ? true : false
      // console.log(this.cloud.switch)
    },
    // 获取我的api调用
    async getMyApi(type) {
      const res = await myApi({ env: type })
      this.$set(
        this.apiInvoke,
        "yesterday",
        res.yesterday_statis == null ? 0 : res.yesterday_statis
      )
      this.$set(
        this.apiInvoke,
        "thisMonth",
        res.month_statis == null ? 0 : res.month_statis
      )
      this.$set(
        this.apiInvoke,
        "successRate",
        res.success_rate == null ? 0 : res.success_rate.split("%")[0]
      )
    },
    // 获取我的订单
    async getMyOrder() {
      const res = await myOrder()
      // console.log(res)
      this.myOrder.toPayNums =
        res.unpaid_order_count == null ? 0 : res.unpaid_order_count
      this.myOrder.toSendNums =
        res.undelivery_order_count == null ? 0 : res.undelivery_order_count
    },
    // 设置预警额度
    async setWarningQuota(data, type, str) {
      const res = await warningQuota({
        warning_resource_quota: data,
        cloud_resource_type: type,
        switch_flag: str,
      })
      return res
      // console.log(res)
      // res.error_code = "0"
    },
    // 获取我的服务
    async getMyService() {
      const res = await myService()
      this.myService.hadNums = res.use_service_count
      this.myService.expireNums = res.expire_service_count
      this.myService.soonExpireNums = res.will_expire_service_count
      // console.log(res)
    },
    // 获取服务推荐列表
    async getServiceList() {
      const res = await serviceList({ page_size: 4 })
      // console.log(res)
      this.recObjs = res
      // this.recObjs.forEach(item => {
      //   this.$set(
      //     item,
      //     "keywords",
      //     item.service_keyword ? item.service_keyword.split(",") : []
      //   )
      // })
    },
    // 获取平台公告列表
    async getNoticeList() {
      const res = await noticeList({ page_size: 10 })
      this.platfromNotice = res
      // console.log(res)
      // var a = blogListURl()
      // console.log(a)
    },
  },
}
</script>

<style lang="scss" scoped>
.common-services {
  margin: 15px auto 0;
  width: 328px;
  .common-services-box {
    float: left;
    width: 102px;
    height: 39px;
    margin: 0 10px 6px 0;
    padding: 0 10px;
    line-height: 39px;
    background-color: #f6f6f6;
    color: #4686f2;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.blue {
  color: #4686f2;
}
body {
  font-family: PingFangSC-Medium;
  color: #333;
}
a {
  color: #4686f2;
}
.user-block {
  background-color: #fff;
  padding: 24px;
  /* margin-right: 8px; */
  margin-top: 12px;
  box-sizing: border-box;
}
.block-title {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  height: 20px;
  font-weight: 700;
}
.block-title-a {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  height: 20px;
  font-weight: 700;
  color: #4686f2;
}
.big-font {
  font-size: 20px;
  line-height: 20px;
}
.pc-trans {
  margin-bottom: 26px;
  display: block;
}
.nomargin {
  margin-right: 0;
}
.user-top {
  display: flex;
}
.welcome {
  height: 104px;
  /* width: 764px; */
  display: flex;
  /* margin-right: 8px; */
}
.welcome2 {
  height: 104px;
  /* width: 764px; */
  display: flex;
  box-sizing: border-box;
  margin-right: 0;
}
.wel-hello {
  color: #333333;
  font-size: 24px;
}
.userinfo1 {
  /* width: 378px; */
  height: 104px;
}
.balance2,
.userinfo2 {
  /* width: 378px; */
  height: 170px;
}
.user-detail {
  font-size: 12px;
  line-height: 24px;
}
.usertype {
  display: inline-block;
  background: #e6f5fe;
  border: 1px solid #037df3;
  border-radius: 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #037df3;
  line-height: 20px;
  width: 64px;
  height: 20px;
  text-align: center;
}
.normarlclass {
  cursor: pointer;
}
.plreeclass {
  color: #4686f2;
  border-bottom: 1px solid #4686f2;
  padding-bottom: 5px;
}
.user-bot {
  display: flex;
}
.myapis,
.balance,
.cloud,
.ploatfrom {
  height: 170px;
  /* width: 378px; */
  display: flex;
  flex-direction: column;
}
.ploatfrom2 {
  height: 170px;
  /* width: 378px; */
  display: flex;
  flex-direction: column;
}
.redclass {
  color: red;
}
.yeclass {
  color: #ffa11a;
}
.balance-cloud {
  align-self: center;
  text-align: center;
}
.money {
  font-size: 24px;
  font-weight: 700;
}
.buyTip {
  color: #666666;
  margin: 12px;
  text-align: center;
  font-weight: 700;
}
.balance-bot {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  align-items: flex-end;
}
.plo-top {
  display: flex;
  justify-content: space-between;
}
.plo-block {
  margin-top: 6px;
}
.plo-notice {
  display: flex;
}
.notice-type {
  display: inline-block;
  width: 64px;
  height: 18px;
  border-radius: 10.5px;
  border-radius: 10.5px;
  text-align: center;
  font-size: 12px;
  margin-right: 12px;
}
.notice-title {
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
  height: 24px;
}
.type0 {
  color: #d04d8b;
  background: #feecfe;
}
.type1 {
  color: #dc6f6f;
  background: #ffeded;
}
.type2 {
  color: #dc8e5b;
  background: #fff2ef;
}
.type3 {
  color: #f8b019;
  background: #fff6e2;
}
.type4 {
  color: #5ea13e;
  background: #e6f4e0;
}
.type5 {
  color: #29adcb;
  background: #e2f8fb;
}
.type6 {
  color: #5289b2;
  background: #eaf3ff;
}
.type7 {
  color: #7f77c6;
  background: #ecefff;
}
.type8 {
  color: #967ab6;
  background: #f1eaf9;
}
.type9 {
  color: #797979;
  background: #efefef;
}
.nothavecloud {
  /* display: flex; */
}

.user-left {
  margin-right: 8px;
}
.balance-user {
  display: flex;
}
/* .user-right {

} */
.other-blocks {
  display: flex;
}
.myservice,
.mygoods {
  /* width: 378px; */
  height: 170px;
}
.plo-center {
  display: flex;
  margin-top: 26px;
  justify-content: space-around;
  text-align: center;
}
.rec-title {
  font-size: 14px;
  font-weight: 700;
}
.col-16 {
  height: 20px;
  background: red;
}
.col-8 {
  height: 40px;
  background: green;
}
</style>
<style lang="scss">
.babot-right {
  .h-switch .slide {
    position: absolute;
    top: 9px;
    left: 9px !important;
  }
}

.h-switch-small.h-switch-checked .slide {
  left: 29px !important;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/consoleViews/vitrualBusiness/constHome.vue